import React from "react";
import { Box, CircularProgress } from "@mui/material";

export default function LoadableButton() {
  return (
    <Box sx={{ zIndex: 9999, position: "fixed", top: 0, left: 0, width: "100vw", height: "100vh", display: "flex", justifyContent: "center", alignItems: "center", backdropFilter: "blur(10px)", backgroundColor: "rgba(255, 255, 255, 0.2)", }}>
      <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", width: "150px", height: "150px", background: "rgba(255, 255, 255, 0.3)", backdropFilter: "blur(15px)", borderRadius: "16px", boxShadow: "0 4px 30px rgba(0, 0, 0, 0.1)", }}>
        <CircularProgress size={64} color="inherit" />
      </Box>
    </Box>
  );
}
